import React from "react";
import { PeekLink, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const ToggleLink = ({ prefixText, linkText, onClick }) => {
    return (React.createElement(PeekStack, { textAlign: "center", direction: "row", gap: 0.5, alignSelf: "center" },
        React.createElement(PeekTypography, { variant: "body2", color: "info" }, prefixText),
        React.createElement(PeekLink, { variant: "body2", onClick: onClick, sx: {
                cursor: "pointer",
                verticalAlign: "baseline",
                transition: "color 0.2s ease-in-out",
                "&:hover": { color: "secondary.main" },
            } }, linkText)));
};
export default ToggleLink;
